import {Component, inject, Input} from '@angular/core';
import {IonicModule, PopoverController} from "@ionic/angular";
import {GlobalService} from "../../../services/global/global.service";
import {NavigationService} from "../../../services/navigations/navigation.service";
import {NgForOf, NgIf, SlicePipe} from "@angular/common";
import {PostModel} from "../../../models/post.model";
import {ApiResponse} from "../../../services/utils";
import {NativeAudio} from "@capgo/native-audio";
import {AuthService} from "../../../services/auth/auth.service";
import {PostService} from "../../../services/post/post.service";
import {StorageService} from "../../../services/storage/storage.service";
import {UserModel} from "../../../models/user.model";
import {MoodModel} from "../../../models/mood.model";

@Component({
    selector: 'app-map-moment',
    templateUrl: './map-moment.component.html',
    styleUrls: ['./map-moment.component.scss'],
    imports: [
        IonicModule,
        NgForOf,
        NgIf,
        SlicePipe
    ],
    standalone: true
})

export class MapMomentComponent {
  @Input() data: PostModel;
  protected user: UserModel;

  private navigationService: NavigationService = inject(NavigationService);
  private globalService: GlobalService = inject(GlobalService);
  private auth: AuthService = inject(AuthService);
  private postService: PostService = inject(PostService);
  private storage: StorageService = inject(StorageService);
  private popOverController: PopoverController = inject(PopoverController);

  constructor() {
    this.user = this.auth.user;
    this.auth.getUserStatus.subscribe((): void => {
      this.user = this.auth.user;
    });
  }

  public getCreatedTime(createdTime: string): string {
    return this.globalService.timeSince(createdTime);
  }

  public async openOtherProfile(id: number): Promise<void> {
    await this.navigationService.openOtherUserProfile(id, false);
  }

  public async openActionPont(id: number): Promise<void> {
    await this.navigationService.openActionPointDetail(id);
  }

  public getMoodOfMoment(moment: PostModel): string {
    return moment.moods.find((mood: MoodModel) => mood.id === moment.hasMood)?.iconSolid || '';
  }

  public setMood(moodId: number, postId: number): void {
    if (this.auth && this.auth.isAuthenticated) {
      const actualMood = this.data.hasMood;
      if (actualMood === 0) {
        this.data.moodsCount += 1;
        this.data.hasMood = moodId;
      } else {
        this.data.hasMood = moodId;
      }

      const input = new FormData();
      input.append('postId', postId.toString());
      input.append('moodId', moodId.toString());

      this.postService.apiSetMood(input).subscribe(async (result: ApiResponse): Promise<void> => {
        if (result?.status && await this.storage.isInteractionSoundOn()) {
          await NativeAudio.play({assetId: 'moment', time: 0});
        }
      });

      setTimeout((): void => {
        this.popOverController.dismiss();
      }, 1000);
    } else {
      this.globalService.openLoginModal();
    }
  }
}
